// extracted by mini-css-extract-plugin
module.exports = {"mobileRow":"MobileRow_mobileRow__1Sajz","row":"MobileRow_row__1n-mo","rowMargin":"MobileRow_rowMargin__29H-b"};